/** ตั้งค่าระบบ — MASTER's page for company-wide settings. */
export const SYSTEM_SETTINGS_PATH = "/system-settings";
